import EditRoute from './EditRoute'

export default EditRoute



// WEBPACK FOOTER //
// ./src/components/Routes/Edit/index.js